import * as React from "react";
import { toast } from "sonner";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { PasswordChangeModal } from "@/components/designSystem";
import { useSyncMyInfo } from "@/hooks/useSyncMyInfo";
import { usePasswordChange } from "@/hooks/usePasswordChange";
import { getPasswordChangeErrorMessage } from "@/api/accountApi";
import { useAccountStore } from "@/common/store/accountStore";
import { usePasswordChangeStore } from "@/common/store/passwordChangeStore";

// 비밀번호 변경 모달은 앱 전역에 한 번만 렌더링하고 store 로 열고 닫는다.
// - 사이드바 프로필 메뉴 → variant="change"
// - 최초 로그인(임시 비밀번호) → variant="first-login" (홈 위에 딤 처리로 노출)
function PasswordChangeModalHost() {
  const { open, variant, closeModal } = usePasswordChangeStore();
  const loginId = useAccountStore((s) => s.user_info?.email);
  const { mutateAsync } = usePasswordChange();

  // 성공 시 서버가 is_temporary_password 를 자동 해제한다.
  // 실패 시 모달이 잡아 필드에 노출하도록 사용자 문구로 변환해 throw
  const handleSubmit = async (newPassword: string) => {
    try {
      await mutateAsync({ new_password: newPassword });
    } catch (error) {
      throw new Error(getPasswordChangeErrorMessage(error));
    }
    toast.success("비밀번호를 변경했어요.");
  };

  return (
    <PasswordChangeModal
      open={open}
      onOpenChange={(next) => {
        if (!next) closeModal();
      }}
      variant={variant}
      loginId={loginId}
      onSubmit={handleSubmit}
    />
  );
}

function MainLayout({ children }: { children: React.ReactNode }) {
  // 새로고침 후 role/affiliation.type 최신화 (권한 분기의 신뢰 소스)
  useSyncMyInfo();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>{children}</SidebarInset>
      <PasswordChangeModalHost />
    </SidebarProvider>
  );
}

export { MainLayout };
